<template>
  <div class="parent">
    <div class="title">
      <VTitle page-title="我的照片"></VTitle>
    </div>

    <div class="photo" ref="scroll">
      <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="photosInfo.disable"
          infinite-scroll-immediate-check="false"
          infinite-scroll-distance="50">
        <li>
          <img v-for="obj, index in photosInfo.photos"
               :src="obj.image_shrinkage"
               v-tap="{methods:click,index:index}"
               alt="" class="photodetail"/>
        </li>
      </ul>

      <div v-show="photosInfo.loadingState != 1" class="bottom">
        <!-- loadingState == 2 显示加载动画状态-->
        <mt-spinner v-show="photosInfo.loadingState == 2" type="fading-circle" color="#cba164"></mt-spinner>
        <span v-text="loadingText"></span>
      </div>
      <div>

      </div>

    </div>
    <div>
      <VGoBackBtn v-on:exit="exit"></VGoBackBtn>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
  import VGoBackBtn from '../../components/VGoBackBtn.vue';
  import VTitle from '../../components/VTitle.vue';
  //  import netTool from '../../api/netTool';
  import { Toast } from 'mint-ui';
  import { mapGetters } from 'vuex';
  export default{
    created() {
      if (this.photosInfo.page === 0) {
        this.loadMore();
      }
      let _that = this;
      this.$nextTick(function () {
        _that.scrollDiv = this.$refs.scroll;
        this.scrollDiv.scrollTop = this.photosInfo.scrollTop;
        _that.scrollDiv.onscroll = function () {
          console.log(this.scrollTop);
          _that.$store.commit('setScrollTop', this.scrollTop);
        };
      });
    },
    data () {
      return {
        scrollDiv: {}
      };
    },
    activated() {
      console.log(this.photosInfo.scrollTop);
      this.scrollDiv.scrollTop = this.photosInfo.scrollTop;
    },
    components: {VGoBackBtn, VTitle},
    methods: {
      loadMore() {
        if (!this.photosInfo.disable) {
          this.$store.dispatch('getPhotos', {toastInfo: this.toastInfo});
        }
      },
      exit () {
        console.log(1111);
//        this.$store.commit('clearPhotosInfo');
      },
      click (params) {
        let index = params.index;
        this.$store.commit('setImgInfo', {imgs: this.photosInfo.photos, index: index});
        this.$router.push({path: '/picture-view'});
      },
      toastInfo(msg) {
        Toast({message: msg, position: 'middle', duration: 3000});
      }
    },
    computed: {
      ...mapGetters([
        'photosInfo',
        'loadingText'
      ])
//      stateText() {
//        let text = '';
//        switch (this.loadingState) {
//          case 1:
//            text = '';
//            break;
//          case 2:
//            text = '加载中...';
//            break;
//          case 3:
//            text = '没有更多内容';
//            break;
//          case 4:
//            text = '您还没有照片';
//            break;
//          case 5:
//            text = '请检查您的网络';
//            break;
//        }
//        return text;
//      }
    }

  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../../assets/scss/base.scss';

  .parent {
    width: px2rem(750);
    @include bg-img('../../assets/img/parentRecord/background');
  }

  .title {
    padding-top: px2rem(40 + 49);
    margin-bottom: px2rem(28);
    text-align: center;
  }

  .photo {
    width: px2rem(640);
    height: px2rem(890);
    background-color: rgba(255, 246, 216, 1);
    border-radius: px2rem(10);
    margin-left: px2rem(55);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .photodetail {
    width: px2rem(200);
    height: px2rem(200);
    margin-left: px2rem(10);
    margin-top: px2rem(10);
  }

  .bottom {
    margin-top: px2rem(10);
    height: px2rem(70);
    line-height: px2rem(70);
    text-align: center;
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: px2rem(30);
      &:nth-child(2) {
        margin-left: px2rem(20);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// MyPhoto.vue?206841ac